/**
 * 登录后"回到原处"的目标路径解析。
 *
 * 背景：`sw_session` 已改回**浏览器会话 Cookie**（关浏览器即失效），所以重启浏览器
 * （或关掉标签页再打开）后会先落到登录页 —— 此时必须记住"当初想进哪儿"，否则登录后
 * 只能去书架。而"回到原来那本书的编辑器"恰恰是关键的：**「有 N 项待确认…前往处理」
 * 提醒只在编辑器里扫**（`WritingMode` 挂载时探测本作品对话的挂起审批/提问），
 * 落到书架就等于把"AI 还在等你拍板"这件事藏了起来，用户可能一直不知道。
 *
 * `next` 来自 URL（任何人都能构造），所以只放行**已知的站内路由前缀** ——
 * 不拿它当"登录后跳任意地址"的跳板。
 */
const ALLOWED_PREFIXES = ['/home', '/editor/', '/reader/', '/harness'] as const;

/** 默认落点：书架 */
export const DEFAULT_NEXT_PATH = '/home';

export function resolveNextPath(raw: string | null | undefined): string {
  if (typeof raw !== 'string' || raw.length === 0) return DEFAULT_NEXT_PATH;
  // 只认站内绝对路径：`//evil.com` 是协议相对地址，反斜杠是浏览器会归一化的变体
  if (!raw.startsWith('/') || raw.startsWith('//') || raw.includes('\\')) return DEFAULT_NEXT_PATH;
  const allowed = ALLOWED_PREFIXES.some(
    (prefix) => raw === prefix || raw.startsWith(prefix),
  );
  return allowed ? raw : DEFAULT_NEXT_PATH;
}
